const R = require('ramda');
const { STATUS_PRIORITY, TRACKER_LIST } = require('../constants');
const { failProofAssign } = require('../utils');
const utils = require('../utils/utils');
const ArchitectureElement = require('./ArchitectureElement');
/** @type {Ad} */
class Ad extends ArchitectureElement {
  constructor(obj) {
    super();
    this.updateData(obj);
  }

  updateData(obj) {
    if (!obj) return;
    obj.channelStatus = obj.status;
    failProofAssign(this, R.omit(['status', 'metric', 'channel'], obj));
  }

  get level() {
    return 'ad';
  }

  set creative(creative) {
    this._creative = creative;
  }

  get creative() {
    let creative = this._creative;
    const proposalAds = R.path(['proposal', 'channelAds'])(this.adrielCampaign);
    if (proposalAds) {
      // TODO: potentially slow, complexity O(n2)
      const proposalAd = proposalAds.find(R.propEq('creativeId', this.proposalCreativeId));
      if (proposalAd && proposalAd.creative) {
        if (creative) {
          creative.params = R.mergeLeft(creative.params, proposalAd.creative);
        } else {
          creative = { params: proposalAd.creative };
        }
      }
    }
    return creative;
  }

  // attachReports(reportsById, leadsByConnectAdId) {
  //   this.reportsAttached = true;
  //   const reports = reportsById[this.channelId];
  //   if (reports) {
  //     this.reports = reports.filter(
  //       (report) => report.metric && (!report.from || new Date(report.from) < new Date()),
  //     );
  //   } else this.reports = [];

  //   // add leads
  //   if (R.path(['adSet', 'campaign', 'isAdrielLeadForm'], this)) {
  //     if (!R.isEmpty(leadsByConnectAdId) && this.connectId) {
  //       this.leads = leadsByConnectAdId[this.connectId] || [];
  //     } else this.leads = [];

  //     // add leads to report data
  //     this.reports = this.reports.map(report => {
  //       const metric = R.merge({ leads: 0 }, report.metric);
  //       let lead;
  //       if (this.reports.length === 1) {
  //         lead = this.leads.length > 0 ? this.leads[0] : null;
  //       } else {
  //         lead = this.leads.find(R.propEq('from', report.from));
  //       }
  //       metric.leads = lead ? lead.value : 0;
  //       if (!report.actions) report.actions = [];
  //       report.actions.push({
  //         type: 'lead',
  //         name: 'lead',
  //         value: metric.leads,
  //       });
  //       return { ...report, metric };
  //     });
  //   }

  //   this.reports = this.reports.map(utils.formatReportWithSpendInActions);
  //   if (this.reports.length === 1) {
  //     this.report = this.reports[0];
  //   }
  // }

  // get status() {
  //     if (!this.adSet) return this.channelStatus;
  //     const adSetStatus = this.adSet.channelStatus;
  //     const campaignStatus = this.adSet.campaign.channelStatus;
  //     const channelStatuses = [
  //         campaignStatus,
  //         adSetStatus,
  //         this.channelStatus,
  //     ];

  //     for (const status of STATUS_PRIORITY) {
  //         if (channelStatuses.includes(status)) return status;
  //     }

  //     return this.channelStatus;
  // }

  get hasConversionGoal() {
    return Boolean(this.adSet.conversionGoal);
  }

  get subChannels() {
    if (this.adSet && this.adSet.subChannels && this.adSet.subChannels.length > 0) return this.adSet.subChannels;
    if (this.campaign && this.campaign.subChannels && this.campaign.subChannels.length > 0)
      return this.campaign.subChannels;
    return [this.channel];
  }

  // get subChannelReports() {
  //   // for facebook we need to check the subChannels details
  //   let subChannelReports = [];
  //   if (this.isFacebook && this.hasMultipleChannels) {
  //     if (this.subChannelDetails && this.subChannelDetails.length > 0) {
  //       subChannelReports = this.subChannelDetails.map(detail => {
  //         const { metric, actions, from, to } = detail;
  //         return {
  //           subChannel: detail.text,
  //           metric,
  //           actions,
  //           from,
  //           to,
  //         };
  //       });
  //     }
  //   } else {
  //     subChannelReports = this.reports.map(report => {
  //       const { metric, actions, from, to } = report;
  //       return {
  //         subChannel: this.subChannels[0],
  //         metric,
  //         actions,
  //         from,
  //         to,
  //       };
  //     });
  //   }
  //   subChannelReports = subChannelReports.map(report => ({
  //     ...report,
  //     metric: this.getMetricFromReport(report),
  //   }));
  //   // fix for lead missing maybe an issue with the pixel event or our form system
  //   if (this.adSet.campaign.isAdrielLeadForm && subChannelReports.length > 0) {
  //     // check if the nb of leads in the subchannels match the nb of leads in the ad
  //     const nbConversions = R.compose(
  //       R.sum,
  //       R.map(R.path(['metric', 'conversions'])),
  //     )(subChannelReports);
  //     const nbLeads = R.compose(R.sum, R.map(R.path(['metric', 'leads'])))(this.reports);
  //     // if we have more leads in the db we should add up in the subchannel
  //     let totalDiff = nbLeads - nbConversions;
  //     if (totalDiff > 0) {
  //       subChannelReports[0].metric.conversions += totalDiff;
  //     } else if (totalDiff < 0) {
  //       totalDiff = Math.abs(totalDiff);
  //       for (const subChannelReport of subChannelReports) {
  //         const conversions = R.path(['metric', 'conversions'], subChannelReport);
  //         let nbConversionToRemove = Math.min(conversions, totalDiff);
  //         subChannelReport.metric.conversions -= nbConversionToRemove;
  //         totalDiff -= nbConversionToRemove;
  //       }
  //     }
  //   }
  //   return subChannelReports;
  // }

  getTotalConversionsByTracker() {
    const conversionsByTracker = this.getConversionsByTracker();
    const totalConversionsByTracker = Object.entries(conversionsByTracker).reduce((obj, [tracker, actions]) => {
      obj[tracker] = actions.reduce((sum, { value }) => sum + (value || 0), 0);
      return obj;
    }, {});
    return totalConversionsByTracker;
  }

  get bidCap() {
    if (this.bidAmount != null) return this.bidAmount;
    return this.adSet && this.adSet.bidCap;
  }

  get bidStrategies() {
    return this.adSet && this.adSet.bidStrategies;
  }

  get objectives() {
    return this.adSet && this.adSet.objectives;
  }

  get campaignId() {
    return this.campaign.channelId;
  }

  format() {
    const obj = super.format();
    if (obj.cell) {
      obj.cell.adName = this.name;
      obj.cell.adId = this.connectId || this.channelId;
      obj.cell.adName = this.name;
      obj.cell.adSetName = this.adSet?.name;
      obj.cell.placements = this.adSet?.placements;
    }
    obj.creativeType = R.path(['creative', 'type'], this);
    obj.creative = this.creative;
    obj.channelLink = this.channelLink;

    obj.previewShareableLink = this.previewShareableLink;
    obj.appId = this.creative?.appId;
    obj.store = this.creative?.store;
    return obj;
  }

  // format() {
  //     // TODO: check if channel is really used by front end. If, no delete getChannel()
  //     const channel = this.getChannel();
  //     const creativeType = R.path(['creative', 'type'], this);

  //     return {
  //         ...R.pick(
  //             [
  //                 'id',
  //                 'channelId',
  //                 'connectId',
  //                 'name',
  //                 'status',
  //                 'channelStatus',
  //                 'metric',
  //                 'subChannels',
  //                 'creative',
  //                 'bidCap',
  //                 'bidStrategies',
  //                 'objectives',
  //                 'campaignId',
  //                 'placements',
  //                 'level',
  //             ],
  //             this
  //         ),
  //         adSet: R.omit(['ads', 'architecture'], this.adSet),
  //         conversionEvents: this.adSet.conversionGoal
  //             ? [this.adSet.conversionGoal]
  //             : null,
  //         conversionsByTracker: this.getConversionsByTracker(),
  //         creativeType,
  //         channel,
  //     };
  // }
  getChannel() {
    const channel = R.path(['campaign', 'channel'])(this);
    if (channel === 'facebook') {
      return R.path(['adSet', 'subChannels', '0'], this) || channel;
    }
    return channel;
  }
  getTitle() {
    const creative = R.path(['creative', 'params'], this);
    return R.path(['title1'], creative) || R.path(['shortTitle'], creative);
  }

  getJSON() {
    const obj = {
      ...R.omit(['adSet', 'campaign', 'report', 'reports', 'architecture', 'FEFormat', '_creative'], this),
      status: this.status,
      creative: this.creative,
      metric: this.metric,
      conversionsByTracker: this.getConversionsByTracker(),
    };
    return obj;
  }
}

module.exports = Ad;
